import React from 'react';
import Button from 'components/DesignSystem/Button';
import Dialog from 'components/DesignSystem/Dialog';
import DialogBody from 'components/DesignSystem/Dialog/Body';
import DialogFooter from 'components/DesignSystem/Dialog/Footer';

type SuccessDialogProps = {
  open: boolean;
  closing: () => void;
};

export default function SuccessDialog({ open, closing }: SuccessDialogProps) {
  return (
    <Dialog open={open} dismiss={closing} type="success" closeButton>
      <DialogBody>
        <p>
          As edições foram salvas
          com sucesso!
        </p>
      </DialogBody>
      <DialogFooter>
        <Button onClick={closing}>Ok</Button>
      </DialogFooter>
    </Dialog>
  );
}
